import { useI18nContext } from '../hooks/contexts/i18n.context';
import * as Style from '../styles/pages/styles.not-found';

const NotFoundPage = () => {
  const { translate } = useI18nContext();

  return (
    <Style.Container id="not-found-page-container">
      <Style.Header id="not-found-page-header">{translate(['INFORMATION', 'PAGE_NOT_FOUND'])}</Style.Header>
      <Style.Text id="not-found-page-text">{translate(['INFORMATION', 'PAGE_NOT_FOUND_MESSAGE'])}</Style.Text>
    </Style.Container>
  );
};

export default NotFoundPage;
